// Konečná cena po množstevní slevě — Shoptet u tabulky ukáže jen ušetřenou částku,
// celkovou cenu za zvolený počet kusů nepřepočítá. Hodnoty bere z jeho markupu
// (.quantity-discounts: data-orig-price, data-amount, data-price-ratio) a z háčku
// na změnu varianty, který předá cenu varianty.
const myQtyPriceTexts = {
    cs: { total: "Celkem za", save: "ušetříte", more: ["další sleva", "další slevy", "dalších slev"], less: "Skrýt další slevy" },
    sk: { total: "Spolu za", save: "ušetríte", more: ["ďalšia zľava", "ďalšie zľavy", "ďalších zliav"], less: "Skryť ďalšie zľavy" },
};

function myQtyPricePlural(count, forms) {
    if (count === 1) return forms[0];
    if (count >= 2 && count <= 4) return forms[1];
    return forms[2];
}

function myQtyPriceFormat(value) {
    const decimals = Number(shoptet.config.decPlaces) || 0;

    if (typeof value.ShoptetFormatAsCurrency === "function") {
        return value.ShoptetFormatAsCurrency(undefined, undefined, decimals);
    }

    const currency = getShoptetDataLayer("currencyInfo") || {};
    const parts = value.toFixed(decimals).split(".");
    let number = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousandSeparator || " ");

    if (parts[1] && Number(parts[1]) !== 0) {
        number += (currency.decimalSeparator || ",") + parts[1];
    }

    return currency.symbolLeft ? currency.symbol + " " + number : number + " " + currency.symbol;
}

function myQtyPriceRound(value) {
    const factor = Math.pow(10, Number(shoptet.config.decPlaces) || 0);
    return Math.round(value * factor) / factor;
}

$(document).ready(function () {
    if (getShoptetDataLayer("pageType") !== "productDetail") return;

    const $table = $(".js-quantity-discounts");
    const $input = $("#product-detail-form input.amount, .p-detail input.amount").first();
    if (!$table.length) return;

    const texts = myQtyPriceTexts[getShoptetDataLayer("language")] || myQtyPriceTexts.cs;

    // Sbalená tabulka (jako na aktin.cz): vidět je aktuální stupeň a nejbližší další,
    // ostatní rozbalí přepínač. Aktuální stupeň se počítá z množství v inputu.
    const $items = $table.find(".js-quantity-discounts__item");
    const $toggle = $("<button type='button' class='myqty-toggle' aria-expanded='false'></button>");
    let expanded = false;

    function getAmount() {
        const amount = Number(String($input.val() || "").replace(",", "."));
        return amount > 0 ? amount : 1;
    }

    function renderCollapse() {
        if ($items.length <= 2) {
            $toggle.remove();
            return;
        }

        const amount = getAmount();
        let current = 0;
        $items.each(function (index) {
            if (Number($(this).attr("data-amount")) <= amount) {
                current = index;
            }
        });

        const first = Math.min(current, $items.length - 2);
        let hidden = 0;
        $items.each(function (index) {
            const near = index >= first && index <= first + 1;
            $(this).toggleClass("myqty-collapsed", !near && !expanded);
            if (!near) hidden++;
        });

        $table.toggleClass("myqty-expanded", expanded);
        $toggle
            .attr("aria-expanded", expanded ? "true" : "false")
            .text(expanded ? texts.less : "+" + hidden + " " + myQtyPricePlural(hidden, texts.more));
    }

    if ($items.length > 2) {
        $toggle.insertAfter($table.find(".quantity-discounts__table"));
        $toggle.on("click", function () {
            expanded = !expanded;
            renderCollapse();
        });
    }

    renderCollapse();
    if (!$input.length) return;
    const unitMatch = $table.find(".quantity-discounts__price-wrapper").first().text().match(/\/\s*(\S+)/);
    const unit = unitMatch ? unitMatch[1] : "ks";

    let basePrice = Number($table.find(".quantity-discounts__table").attr("data-orig-price"));
    let discountsEnabled = true;

    const $box = $("<div class='myqty-price' aria-live='polite'></div>");
    $box.insertAfter(".p-final-price-wrapper");

    function getRatio(amount) {
        let ratio = 1;
        let bestAmount = 0;

        $table.find(".js-quantity-discounts__item").each(function () {
            const itemAmount = Number($(this).attr("data-amount"));
            if (itemAmount <= amount && itemAmount > bestAmount) {
                bestAmount = itemAmount;
                ratio = Number($(this).attr("data-price-ratio")) || 1;
            }
        });

        return ratio;
    }

    function render() {
        const amount = Number(String($input.val()).replace(",", "."));
        const tableVisible = !$table.hasClass("js-hidden") || $table.hasClass("visible");

        if (!discountsEnabled || !tableVisible || !basePrice || !amount || amount <= 1) {
            $box.removeClass("is-visible").empty();
            return;
        }

        const unitPrice = myQtyPriceRound(basePrice * getRatio(amount));
        const total = myQtyPriceRound(unitPrice * amount);
        const saved = myQtyPriceRound(basePrice * amount - total);

        let html = "<span class='myqty-price-total'>" + texts.total + " " + amount + " " + unit + ": <strong>" + myQtyPriceFormat(total) + "</strong></span>";

        if (saved > 0) {
            html += "<span class='myqty-price-unit'>" + myQtyPriceFormat(unitPrice) + " / " + unit + "</span>" +
                "<span class='myqty-price-save'>" + texts.save + " " + myQtyPriceFormat(saved) + "</span>";
        }

        $box.html(html).addClass("is-visible");
    }

    $input.on("change input", function () {
        render();
        renderCollapse();
    });

    document.addEventListener("ShoptetQuantityDiscountUpdated", function () {
        render();
        renderCollapse();
    });

    // Změna varianty: Shoptet volá onVariantChange(slevy zapnuté, cena varianty, min. množství)
    shoptet.scripts.setCustomCallback("shoptet.quantityDiscounts.onVariantChange", function (args) {
        discountsEnabled = !!args[0];
        if (args[0] && typeof args[1] === "number" && !isNaN(args[1])) {
            basePrice = args[1];
        }
        render();
        renderCollapse();
    });

    render();
});
